import get from "lodash/get";

/**
 * if array includes value remove it else add it
 */
export const arrayToggle = (array, value) => {
  if (array.includes(value)) {
    return array.filter((x) => x !== value);
  } else {
    return [...array, value];
  }
};

/**
 * Symmetrical difference of 2 arrays
 * @param {*} arrA
 * @param {*} arrB
 *
 * return elements that are not present in both arrays
 */
export const arraySimDiff = (arrA, arrB) => {
  return arrA
    .filter((x) => !arrB.includes(x))
    .concat(arrB.filter((x) => !arrA.includes(x)));
};

/**
 * Filter out items whose id (read from `idField`, supports nested paths like
 * "zone.id") matches one of the already-selected items. Used by autocompletes
 * in multi-select mode to hide already-picked options from the dropdown.
 *
 * @param {Array} items list of candidate items
 * @param {Array} selectedItems currently selected items
 * @param {string} idField path to the identity field (e.g. "id", "zone.id")
 * @returns {Array} items with the selected ones removed
 */
export const excludeSelectedItems = (items, selectedItems, idField) => {
  const selectedIds = new Set(
    (selectedItems ?? []).map((item) => get(item, idField))
  );
  return items.filter((item) => !selectedIds.has(get(item, idField)));
};

/**
 * Parse a URL hash string in the form `key=value&key2=value2` into an object.
 * Accepts the raw `window.location.hash` (leading `#` is stripped) or an
 * already-stripped string. Values are URI-decoded; malformed pairs are skipped.
 *
 * @param {string} hashString raw or `#`-stripped hash fragment
 * @returns {Object} map of decoded params (empty object when nothing parseable)
 */
export const parseHashParams = (hashString) => {
  const params = {};
  if (!hashString) {
    return params;
  }
  const stripped = hashString.startsWith("#")
    ? hashString.substring(1)
    : hashString;
  stripped.split("&").forEach((param) => {
    const [key, value] = param.split("=");
    if (key && value) {
      params[key] = decodeURIComponent(value);
    }
  });
  return params;
};
